/**
 * app引入webview的环境下需要使用@cvte/native-proxy来建立app的通信
 */
import { isWebInApp } from '@helpers/Constants';
const cache = new Map()

let resolve: (value: any) => void, reject: (err: any) => void

const promisePkg = new Promise<any>((_resolve, _reject) => {
  console.log('res')
  resolve = _resolve
  reject = _reject
})

console.log(isWebInApp(), 'isWebInApp()');
if(isWebInApp()) {
  // eslint-disable-next-line
  (async () => {
    try {
      const { default: NativeProxy } = await import('@cvte/native-proxy');
      console.log(NativeProxy, 'NativeProxy1')
      resolve(NativeProxy)
    } catch (e) {
      console.log(e, 'e')
      return reject(e)
    }
  })();
}

//获取NativeProxy某个context的单例
export const getNativeProxySington = async (context: string) => {
  if(!isWebInApp()) {
    throw new Error('[yunban]非App环境');
  }

  if(cache.has(context)) {
    return cache.get(context)
  } else {
    const NativeProxy = await promisePkg;
    const instance = new NativeProxy({
      context,
      // nativeCbName: appEventCallbackName,
      webCbName: 'appEventCallback'
    })
    cache.set(context, instance);
    return instance
  }
}